import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCorePoliciesRoute: InvariantJiraRoute = {
	name: 'project-settings-core-policies',
	path: '/jira/core/projects/:projectKey/settings/policies',
	exact: true,
};
